import React from "react";
import { ListEditor } from "../../components/list-editor";
import { FieldTableColumnProps } from 'components/FieldTable/FieldTableTypes';
import {Pack, PackQueryQuery, usePackQueryQuery, usePacksMutationMutation} from "../../generated/graphql";
import { Tooltip } from "@mui/material";
import {Help} from "@mui/icons-material";
import {StyleSelect} from "../../components/MaterialSelects/StyleSelect";
import {useLocation} from "react-router";
import {FieldTableTitleTooltip} from "../../components/FieldTable/FieldTableTitleTooltip";
import {uniqueId} from "../../utils";

function newRow():Pack {
    return {
        id: uniqueId(),
        label: '',
        style: null
    }
}

const columns:FieldTableColumnProps<Pack>[] = [{
    header: 'Name',
    accessor: 'label',
    dataType:'text'
},{
    headerRaw:'Style',
    header: <Tooltip title="Styling used when displaying this pack on the panel bookings page"><FieldTableTitleTooltip>Style</FieldTableTitleTooltip></Tooltip>,
    accessor: 'style',
    width: 'full',
    sort: 'style.label',
    dataType:'select',
    options: {
        label:'label',
        renderEditor: ({ field }) => <StyleSelect isPackStyle={true} allowBlank={true} {...field} autoFocus={true} />
    }
}
];

const relationships = {
    'style':'connect'
}

function getValues(data:PackQueryQuery): Pack[] {
    console.log('data is',data);
    return data?.packs;
}

const Packs = () => {
    const query = usePackQueryQuery();
    const [mutation,mutationResult] = usePacksMutationMutation();
    const url = useLocation().pathname;
    return (
        <ListEditor
            columns={columns}
            title="Packs"
            query={query}
            relationships={relationships}
            mutation={mutation}
            saveResult={mutationResult}
            getValues={getValues}
            baseUrl={url}
            className="packs"
            newRow={newRow}
            permission="sites"
            newRowLabel="Add Pack"
        />);
}

export default Packs;
